export const TimeSlotUtils = {
  broadwayProductTime2Timeslot: (x: string) => {
    // 7:00PM => 19:00
    return x.replace(/([0-9]{1,2}):([0-9]{2})([AP]M)/, (match, p1, p2, p3) => {
      let hours = parseInt(p1);
      if (p3 === "PM" && hours < 12) {
        hours += 12;
      } else if (p3 === "AM" && hours === 12) {
        hours = 0;
      }
      return `${hours.toString().padStart(2, "0")}${p2}`;
    });
  },
  timeSlot2BroadwayProductTime: (x: string) => {
    // 19:00 => 7:00PM
    const hours = parseInt(x.slice(0, 2));
    const minutes = x.slice(2);
    const period = hours >= 12 ? "PM" : "AM";
    const adjustedHours = hours % 12 || 12; // Convert 0 to 12 for AM/PM format
    return `${adjustedHours}:${minutes} ${period}`;
  },
};
